export class Microsoft365GraphPermission {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "displayName",
            "baseName": "displayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "graphScope",
            "baseName": "graphScope",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Microsoft365GraphPermission.attributeTypeMap;
    }
    constructor() {
    }
}
